import React, { useEffect, useState } from "react";
import ProjLargeOffsetImage from "../ProjLargeOffsetImage/ProjLargeOffsetImage";
import ProjSplitImages from "../ProjSplitImages/ProjSplitImages";
import ProjMinorQuoteTile from "../ProjMinorQuoteTile/ProjMinorQuoteTile";
import './styles.css';


const ProjVariableSection = ({data, fullSize, halfSize, threeQSize, content, aspectRatio}) => {

    const [displayLargeOffset, setDisplayLargeOffset] = useState(null);
    const [displaySplit, setDisplaySplit] = useState(null);
    const [displayPostSplitLarge, setDisplayPostSplitLarge] = useState(null);
    const [displayMinorQuote, setDisplayMinorQuote] = useState(null);
    const [displayExtraContent, setDisplayExtraContent] = useState(null);
    
    const [extraContent, setExtraContent] = useState(null);
    const [splitData, setSplitData] = useState(null);
    const [minorQuoteData, setMinorQuoteData] = useState(null);
    const [randomPositioning, setRandomPositioning] = useState(null);

    useEffect(() => {
    }, [displaySplit])
    
    // Generate pseudi-random positioning values
    // This is only called when the number of stills exceeeds a certain threshold
    // When this happens we generate the fixed structure, and any remaining stills have their width
    // and left offset determined by ths function, which is coded such that if the previous
    // elment is small, it is more likely to be large, if it is to the right, it is more likely to be to the left,
    // as such it is designed to pseudo-randomly generate a balanced run of images of varying sizes
    // and positions
    const generateRandomPositioning = (numberOfTiles) => {
        let maxWidth = 0.9;
        let minWidth = 0.4;
        let midpoint = (maxWidth + minWidth)/2;
        let range = maxWidth - minWidth;
        let previousWidth = 0.75;
        let previousRelativeLeftBias = 0;
        let generatedPositions = [];
        let isFirstVal = true;
        for(let i = 0; i<numberOfTiles; i++){
            let rand = Math.random()
            let tileWidth = (rand * range) + minWidth
            let prevWidthAdjustment = (midpoint - previousWidth)/3;
            let adjustedTileWidth = Math.min(Math.max(tileWidth + prevWidthAdjustment, minWidth), maxWidth);
            if(isFirstVal){
                let leftOffset = 0.1;
                previousRelativeLeftBias = 0.3;
                generatedPositions.push({
                    'width': adjustedTileWidth,
                    'leftVal': leftOffset
                })
                isFirstVal = false;
            } else{
                let leftOffset = Math.random() * (1 - adjustedTileWidth) + (previousRelativeLeftBias * (1 - adjustedTileWidth));
                let adjustedLeftOffset = Math.max((Math.min(1 - adjustedTileWidth, leftOffset)), 0)
                previousRelativeLeftBias = (((1 - adjustedTileWidth)/2) - adjustedLeftOffset) / (1 - adjustedTileWidth);
                generatedPositions.push({
                    'width': adjustedTileWidth,
                    'leftVal': adjustedLeftOffset
                })
            }
        }
        setRandomPositioning(generatedPositions)
    }

    useEffect(() => {
        // Handles the different arrangements of the variable
        if(data.length == 1){
            setDisplayLargeOffset(true);
            setDisplaySplit(false);
            setDisplayPostSplitLarge(false);
            setDisplayMinorQuote(false);
            setDisplayExtraContent(false);
        } else if (data.length == 2){
            setDisplayLargeOffset(false);
            setDisplaySplit(true);
            setSplitData([data, content.splitQuote]);
            setDisplayPostSplitLarge(false);
            setDisplayMinorQuote(false);
            setDisplayExtraContent(false);
        } else if(data.length == 3){
            setDisplayLargeOffset(true);
            setDisplaySplit(true);
            setSplitData([data.slice(1, 3), content.splitQuote]);
            setDisplayPostSplitLarge(false);
            setDisplayMinorQuote(false);
            setDisplayExtraContent(false);
        } else if (data.length == 4){
            setDisplayLargeOffset(true);
            setDisplaySplit(true);
            setSplitData([data.slice(1, 3), content.splitQuote]);
            setDisplayPostSplitLarge(true);
            setDisplayMinorQuote(false);
            setDisplayExtraContent(false);
        } else if (data.length == 5){
            setDisplayLargeOffset(true);
            setDisplaySplit(true);
            setSplitData([data.slice(1, 3), content.splitQuote]);
            setDisplayPostSplitLarge(true);
            if(content.minorQuote){
                setDisplayMinorQuote(true);
                setMinorQuoteData([data[4], content.minorQuote])
                setDisplayExtraContent(false);
            } else{
                setDisplayMinorQuote(false);
                setDisplayExtraContent(true);
                setExtraContent(data[4])
                generateRandomPositioning(1);
            }
        } else if(data.length >= 6){
            setDisplayLargeOffset(true);
            setDisplaySplit(true);
            setSplitData([data.slice(1, 3), content.splitQuote]);
            setDisplayPostSplitLarge(true);
            if(content.minorQuote){
                setDisplayMinorQuote(true);
                setMinorQuoteData([data[4], content.minorQuote])
                generateRandomPositioning(data.length - 5);
                setExtraContent(data.slice(5, data.length));
            }
            else{
                setDisplayMinorQuote(false);
                generateRandomPositioning(data.length - 4);
                setExtraContent(data.slice(4, data.length))
            }
            setDisplayExtraContent(true);
        }
    }, [])
    return(
        <>
            {displayLargeOffset &&
                <ProjLargeOffsetImage
                    src={data[0].backgroundImage}
                    setPosition={"right"}
                    setWidth={"80%"}
                />
            }
            {
                displaySplit &&
                <>
                    <ProjSplitImages 
                        srcs={splitData[0]}
                        size={halfSize}
                        quotes={splitData[1]}
                        aspectRatio={aspectRatio}
                    />
                </>
            }
            {
                displayPostSplitLarge &&
                <ProjLargeOffsetImage
                    src={data[3].backgroundImage}
                    size={fullSize}
                    setPosition={"left"}
                    setWidth="100%"
                    setPadding="0vh 3% 35vh 2%"
                    aspectRatio={aspectRatio}
                />
            }
            {
                minorQuoteData && 
                <ProjMinorQuoteTile 
                    data={minorQuoteData[0]}
                    size={threeQSize}
                    minorQuote={minorQuoteData[1]}
                    extraBelow={extraContent}
                    aspectRatio={aspectRatio}
                />
            }
            {
                //Excess images to render the random generateed positions
                randomPositioning && extraContent &&
                <div className="extra_content__wrapper">
                    {
                        randomPositioning.map((item, idx) => (
                            
                            <ProjLargeOffsetImage
                                src={extraContent[idx].backgroundImage}
                                setPosition={"left"}
                                size={fullSize}
                                setWidth={item.width*100 + "%"}
                                setLeft={`${item.leftVal*100}%`}
                                setPadding={idx == (randomPositioning.length - 1) ? "0" : `0 0 20vh 0%`}
                                aspectRatio={aspectRatio}
                            />
                        ))
                    }
                </div>
            }
        </>
    )
}

export default ProjVariableSection;